export const getVenueImage = (venue, size = ' thumbnail') => {
  const { images: { thumbnail = [], regular = [] } = {} } = venue;

  return size === 'thumbnail' ? thumbnail[0] : regular[0];
};
